export default function useLoading(initial: boolean = false) {
  const isLoading = ref<boolean>(initial);
  const startLoading = () => isLoading.value = true;
  const stopLoading = () => isLoading.value = false;

  return { isLoading, startLoading, stopLoading }
}
